import "@stencil/redux";
import "classlist-polyfill";
import "scroll-behavior-polyfill";
import "element-closest-polyfill";
import "../interceptors/fetch-interceptor";
import "unfetch/polyfill";
import "abortcontroller-polyfill";

// TT CUSTOM START
declare global {
  interface Window {
    mediator: any;
  }
}
// TT CUSTOM END
